import {
    Grid,
    Box,
    Typography,
    Button,
    Card,
    CardContent,
    CardActions,
    Accordion,
    AccordionSummary,
    AccordionDetails
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import tooltips from '../../../store/tooltips';
import RofTooltip from '../rofburns/shared-components/RofTooltip';

export default function Resources() {
    const resources = [
        {
            title: 'International Resources',
            items: [
                {
                    name: 'International Biochar Initiative',
                    link: 'https://biochar-international.org/',
                },
                {
                    name: 'Wilson Biochar',
                    link: 'https://wilsonbiochar.com/resources',
                },
                {
                    name: 'Piled Fuels Biomass and Emissions Calculator',
                    link: 'https://depts.washington.edu/nwfire/piles/',
                }
            ],
        },
        {
            title: 'South African Resources',
            items: [
                {
                    name: 'Calculate runoff losses to Invasive Alien Plants',
                    text: "Helps determine the water runoff losses from the invasive plants on your land",
                    link: 'https://gmoncrieff.shinyapps.io/aliens_waterloss/',
                },
            ],
        },
    ];

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
            <Box>
                <Typography variant='h5' component='h5'>
                    Biochar Resources
                    <RofTooltip tooltipText={tooltips.resources} />
                </Typography>
            </Box>
            <Box>
                {resources.map((resource, index) => (
                    <Accordion key={index}>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel1a-content"
                            id="panel1a-header"
                        >
                            <Typography variant='h7' >
                                {resource.title}
                            </Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            <Grid container spacing={3} direction='row' alignItems="stretch">
                                {resource.items.map((item, index) => (
                                    <Grid item key={index} xs={3}>
                                        <Card variant='outlined' sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between', height: '100%', py: 1, borderRadius: 4 }}>
                                            <CardContent sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', textAlign: 'center', gap: 1, }}>
                                                <Typography>{item.name}</Typography>
                                                <Typography color="text.secondary">{item.text}</Typography>
                                            </CardContent>
                                            <CardActions sx={{ display: 'flex', justifyContent: 'center' }}>
                                                <Button
                                                    variant='outlined'
                                                    size='small'
                                                    onClick={() => window.open(item.link)}
                                                >
                                                    View
                                                </Button>
                                            </CardActions>
                                        </Card>
                                    </Grid>
                                ))}
                            </Grid>
                        </AccordionDetails>
                    </Accordion>
                ))}
            </Box>
        </Box>
    );
}
